export const getBusinessUserProfileImageUrl = (profilePic) => {
  const BASE_URL =
    process.env.REACT_APP_BACKEND_BASE_URL || "http://localhost:5000";

  // No image → fallback
  if (!profilePic) {
    return `${BASE_URL}/uploads/businessuser_pics/default.png`;
  }

  // If profilePic is an object, extract the actual path/url
  if (typeof profilePic === "object") {
    profilePic =
      profilePic.url ||
      profilePic.path ||
      profilePic.filename ||
      profilePic.fileName ||
      profilePic.src ||
      profilePic.location ||
      "";
  }

  // Still not a string → fallback
  if (typeof profilePic !== "string") {
    return `${BASE_URL}/uploads/businessuser_pics/default.png`;
  }

  profilePic = profilePic.trim();

  if (!profilePic) {
    return `${BASE_URL}/uploads/businessuser_pics/default.png`;
  }

  // Normalize Windows path → URL path
  let cleanPath = profilePic.replace(/\\/g, "/");

  // Already a complete URL
  if (
    cleanPath.startsWith("http://") ||
    cleanPath.startsWith("https://")
  ) {
    return encodeURI(cleanPath);
  }

  // Extract everything starting from "uploads/"
  const uploadIndex = cleanPath.toLowerCase().indexOf("uploads/");

  if (uploadIndex !== -1) {
    cleanPath = cleanPath.substring(uploadIndex);
  }

  // Remove Windows drive letter such as D:/
  cleanPath = cleanPath.replace(/^[a-zA-Z]:\//, "");

  // Remove duplicate leading slashes
  cleanPath = cleanPath.replace(/^\/+/, "");

  // Ensure uploads path
  if (!cleanPath.toLowerCase().startsWith("uploads/")) {
    cleanPath = `uploads/${cleanPath}`;
  }

  const finalUrl = `${BASE_URL}/${cleanPath}`;

  return encodeURI(finalUrl);
};
// export const getBusinessUserProfileImageUrl = (profilePic) => {
//   const BASE_URL =
//     process.env.REACT_APP_BACKEND_BASE_URL || "http://localhost:5000";

//   // ❌ No image → fallback
//   if (!profilePic) {
//     return `${BASE_URL}/uploads/businessuser_pics/default.png`;
//   }

//   // 🔥 Normalize Windows → URL format
//   let cleanPath = profilePic.replace(/\\/g, "/");

//   // 🔥 If already full URL, return as-is
//   if (cleanPath.startsWith("http://") || cleanPath.startsWith("https://")) {
//     return encodeURI(cleanPath);
//   }

//   // 🔥 Always extract from "uploads/" (most reliable fix)
//   const uploadIndex = cleanPath.toLowerCase().indexOf("uploads/");
//   if (uploadIndex !== -1) {
//     cleanPath = cleanPath.substring(uploadIndex);
//   }

//   // 🔥 Remove drive letters like "D:/"
//   cleanPath = cleanPath.replace(/^[a-zA-Z]:\/?/, "");

//   // 🔄 Ensure leading slash
//   if (!cleanPath.startsWith("/")) {
//     cleanPath = `/${cleanPath}`;
//   }

//   const finalUrl = `${BASE_URL}${cleanPath}`;

  

//   return encodeURI(finalUrl);
// };
